import React from 'react';
import DefaultLayout from '../../../layouts/default';
import { UserDetailProvider } from './context/UserDetailContext';
import UserDetailHeader from './components/UserDetailHeader';
import UserProfileDetails from './components/UserProfileDetails';
export default function UserDetailPage() {
  return <DefaultLayout><UserDetailProvider><UserDetailHeader /><UserProfileDetails /></UserDetailProvider></DefaultLayout>;
}
